import { connect } from "react-redux";
// import * as Api from "./api";
import Cookies from "js-cookie";
// const callTranslate = async function () {
//   const data = await Api.Get("get_job_category", "");
//   console.log(data);
//   // return data;
// };

const i18n = function (lang, str) {
  const translations = {
    en: require("../locales/en.json"),
    th: require("../locales/th.json"),
  };

  if (!lang || typeof lang !== "string") {
    return str;
  } else {
    if (lang.length > 2) {
      lang = lang.substring(0, 2);
    }
    return translations[lang] && translations[Cookies.get("locale")][str]
      ? translations[Cookies.get("locale")][str]
      : str;
  }
};

const Translate = function (props) {
    return i18n(props.lang.locale, props.text);
//   return callTranslate();`
};

const mapStateToProps = (state) => ({
  lang: state.lang,
});

export default connect(mapStateToProps, null)(Translate)
